<template>
    <div class="attendance_group_wrap">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left"></div>
            <div class="page-filter_wrap_right">
                <el-button type="primary" @click="handleClickAdd">新增考勤组</el-button>
            </div>
        </div>
        <div class="page-content" v-loading="loading">
            <CustomVxeTable
                ref="tableRef"
                :tableData="attendanceGroupeData"
                :reduceHeight="reduceHeight"
                :showPagination="false"
            >
                <vxe-column field="attendance_group_name" title="考勤组名称"> </vxe-column>
                <vxe-column field="use_user" title="考勤人员" show-overflow>
                    <template #default="{ row }">
                        <template v-if="row.use_user">
                            <span :key="index" v-for="(item, index) in row.use_user" v-if="item.relate_name"
                                >{{ item.relate_name }} <span v-if="index + 1 < row.use_user.length">、</span></span
                            >
                        </template>
                        <div v-else>--</div>
                    </template>
                </vxe-column>
                <vxe-column field="work_time" title="考勤组时间">
                    <template #default="{ row }">
                        <div class="ellipsis" v-if="row.work_time">
                            <span :key="index" v-for="(item, index) in row.work_time"
                                >{{ item.start_time }}-{{ item.end_time
                                }}<span v-if="index + 1 < row.work_time.length">、</span></span
                            >
                        </div>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="80">
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-tooltip effect="dark" content="编辑" placement="top"
                                ><i class="iconfont icon-bianji" @click="handleClickEdit(row)"></i
                            ></el-tooltip>
                            <el-tooltip effect="dark" content="删除" placement="top"
                                ><i class="iconfont icon-shanchu1" @click="handleClickDel(row)"></i
                            ></el-tooltip>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img">
                            <img src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png" alt="">
                        </div>
                        <p class="custom-table-empty-txt">暂无数据</p>
                    </div>
                </template>
            </CustomVxeTable>
        </div>
        <AttendanceGroupTpl
            ref="attendanceGroupTpl"
            :groupTplDialogVisible.sync="groupTplDialogVisible"
            :editId.sync="editId"
            @callbackSuccess="getTableData"
            v-if="groupTplDialogVisible"
        />
    </div>
</template>

<script>
import { AttendanceGroupList, DeleteAttendanceGroup } from "@/api";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import AttendanceGroupTpl from "./component/attendance_group_tpl.vue";
export default {
    name: "AttendanceGroup",
    components: { CustomVxeTable, AttendanceGroupTpl },
    data() {
        return {
            loading: false,
            reduceHeight: 170,
            attendanceGroupeData: [],
            groupTplDialogVisible: false,
            editId: "",
        };
    },
    created() {
        this.getTableData();
    },
    methods: {
        // 新增考勤组
        handleClickAdd() {
            this.editId = "";
            this.groupTplDialogVisible = true;
        },
        // 编辑
        handleClickEdit(row) {
            this.editId = row.id;
            this.groupTplDialogVisible = true;
        },
        // 删除
        handleClickDel(row) {
            this.$msgbox({
                title: "确定删除该考勤组吗？",
                message: "删除后，适用范围内的员工无需参与考勤，已生成的考勤数据不会被删除！",
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                confirmButtonClass: "el-button--danger",
                iconClass: "iconfont icon-jinggao",
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: "icon_title_message_box icon_title_message_box_danger attendance_message_custom",
            })
                .then(() => {
                    this.loading = true;
                    DeleteAttendanceGroup({ id: row.id }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getTableData();
                            this.loading = false;
                        } else {
                            this.loading = false;
                            this.$message.error(res.message);
                        }
                    });
                })
                .catch(() => {});
        },
        // 列表
        getTableData() {
            this.loading = true;
            AttendanceGroupList({
                keyword: "",
            }).then((res) => {
                if (res.code === 200) {
                    this.attendanceGroupeData = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.attendance_group_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .page-filter_wrap {
        padding: 16px 16px 0;
    }
    .page-content {
        flex: 1;
        padding: 0 16px 16px;
    }
}
</style>
<style lang="scss">
.el-message-box__wrapper {
    .attendance_message_custom {
        width: 390px;
    }
}
</style>
